// src/utils/serviceLoader.ts

import { mockUnclaimedContentService } from '@/services/mockUnclaimedContentService';

let _unclaimedContentService: any = null;

export const getUnclaimedContentService = async () => {
  // Return cached service if already loaded
  if (_unclaimedContentService) {
    return _unclaimedContentService;
  }

  const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';
  
  if (useMock) {
    console.log('🔧 Using Mock Unclaimed Content Service');
    _unclaimedContentService = mockUnclaimedContentService;
    return _unclaimedContentService;
  }
  
  // Try to load real service
  try {
    const { unclaimedContentService } = await import('@/services/unclaimedContentService');
    _unclaimedContentService = unclaimedContentService;
    console.log('✅ Using Real Unclaimed Content Service');
    return _unclaimedContentService;
  } catch (error) {
    console.warn('⚠️ Real service not available, falling back to mock service');
    _unclaimedContentService = mockUnclaimedContentService;
    return _unclaimedContentService;
  }
};